import { trimCategoryDropdownsObj } from "components/PimDashboard/DashboardComponents/Sourcing/TrimsMaster/data";

export const TRIM_SOURCE_TYPES = {
	TRIM_MASTER: "TRIM_MASTER",
	ZIPPER: "ZIPPER",
	THREAD: "THREAD",
};

export const trimBreakdownCatalogFields = {
	trim_source_type: "trim_source_type",
	zipper_type_code: "zipper_type_code",
	puller_size_code: "puller_size_code",
	metal_finish: "metal_finish",
	tape_color_code: "tape_color_code",
	zipper_length: "zipper_length",
	thread_item_code: "thread_item_code",
	thread_shade_code: "thread_shade_code",
};

export const TRIM_BREAKDOWN_PRESERVE_KEYS = [
	trimBreakdownCatalogFields.trim_source_type,
	trimBreakdownCatalogFields.zipper_type_code,
	trimBreakdownCatalogFields.puller_size_code,
	trimBreakdownCatalogFields.metal_finish,
	trimBreakdownCatalogFields.tape_color_code,
	trimBreakdownCatalogFields.zipper_length,
	trimBreakdownCatalogFields.thread_item_code,
	trimBreakdownCatalogFields.thread_shade_code,
	"item_description",
];

export const getPullerSizeCodeValue = (row = {}) =>
	row?.puller_size_code ||
	[row?.puller_code, row?.puller_size].filter((value) => value !== null && value !== undefined && String(value).trim() !== "").join(" ");

export const getTrimSourceTypeForCategory = (itemCategory) => {
	if (itemCategory === trimCategoryDropdownsObj?.ZIPPER?.key) return TRIM_SOURCE_TYPES.ZIPPER;
	if (itemCategory === trimCategoryDropdownsObj?.THREAD?.key) return TRIM_SOURCE_TYPES.THREAD;
	return TRIM_SOURCE_TYPES.TRIM_MASTER;
};

export const buildZipperBreakdownDescription = (row = {}, catalogs = {}) => {
	const zipperType = catalogs.zipperTypes?.find((item) => item.zipper_type_code === row.zipper_type_code);
	const parts = [
		zipperType?.code,
		getPullerSizeCodeValue(row),
		row.metal_finish,
		row.tape_color_code,
		row.zipper_length,
	].filter(Boolean);
	return parts.join(" ").trim();
};

export const buildThreadBreakdownDescription = (row = {}, catalogs = {}) => {
	const threadItem = catalogs.threadItems?.find((item) => item.thread_item_code === row.thread_item_code);
	if (!threadItem?.code) return "";
	return `${threadItem.code} SHADE-${row.thread_shade_code || ""}`.trim();
};

export const isBreakdownRowComplete = (row = {}, itemCategory = "") => {
	if (itemCategory === trimCategoryDropdownsObj?.ZIPPER?.key) {
		return isZipperEditorDraftComplete(row);
	}
	if (itemCategory === trimCategoryDropdownsObj?.THREAD?.key) {
		return isThreadEditorDraftComplete(row);
	}
	return Boolean(row?.trim_code && row.trim_code !== "SELECT");
};

const hasValue = (value) => value !== null && value !== undefined && String(value).trim() !== "";

export const pickZipperDraftFromRow = (row = {}) => ({
	[trimBreakdownCatalogFields.zipper_type_code]: row?.zipper_type_code ?? null,
	[trimBreakdownCatalogFields.puller_size_code]: getPullerSizeCodeValue(row) || null,
	[trimBreakdownCatalogFields.metal_finish]: row?.metal_finish ?? "",
	[trimBreakdownCatalogFields.tape_color_code]: row?.tape_color_code ?? "",
	[trimBreakdownCatalogFields.zipper_length]: row?.zipper_length ?? "",
});

export const pickThreadDraftFromRow = (row = {}) => ({
	[trimBreakdownCatalogFields.thread_item_code]: row?.thread_item_code ?? null,
	[trimBreakdownCatalogFields.thread_shade_code]: row?.thread_shade_code ?? "",
});

export const isZipperEditorDraftComplete = (draft = {}) => {
	if (!hasValue(draft?.zipper_type_code)) return false;
	if (!hasValue(draft?.puller_size_code)) return false;
	if (draft?.metal_finish === null || draft?.metal_finish === undefined) return false;
	if (!hasValue(draft?.tape_color_code)) return false;
	return true;
};

export const isThreadEditorDraftComplete = (draft = {}) =>
	hasValue(draft?.thread_item_code) && hasValue(draft?.thread_shade_code);

export const isCatalogDrivenTrimCategory = (itemCategory) =>
	itemCategory === trimCategoryDropdownsObj?.ZIPPER?.key || itemCategory === trimCategoryDropdownsObj?.THREAD?.key;
